import type { QueryKey } from "@tanstack/react-query";

export const BASE_QUERY_KEY: QueryKey = ["screenshots"];

export const getScreenshotQueryKey = (hostId: string, nodeId: number): QueryKey => [...BASE_QUERY_KEY, hostId, nodeId];

export const getScreenshotLanguageCodeQueryKey = (hostId: string, nodeId: number, languageCode: string): QueryKey => [
  ...getScreenshotQueryKey(hostId, nodeId),
  languageCode,
];

export const getScreenshotLanguageCodeHashQueryKey = (
  hostId: string,
  nodeId: number,
  languageCode: string,
): QueryKey => [...getScreenshotLanguageCodeQueryKey(hostId, nodeId, languageCode), "hash"];
